import { Link } from "react-router-dom";
import { ArrowRight, Clock, PlayCircle } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { useBlog } from "@/hooks/use-blog";

export const ArticleCard = ({ a }) => {
  const inner = (
    <>
      {a.cover_image_url && !a.placeholder && (
        <img src={a.cover_image_url} alt="" loading="lazy" className="mb-5 aspect-[16/9] w-full rounded-xl object-cover" />
      )}
      <div className="flex items-center justify-between gap-3">
        <span className="rounded-full bg-gold/10 px-3 py-1 font-display text-[11px] font-bold uppercase tracking-wider text-gold">{a.category}</span>
        <span className="flex shrink-0 items-center gap-1 text-[11px] text-slate2">
          {a.embed_url ? <PlayCircle className="h-3 w-3" /> : <Clock className="h-3 w-3" />} {a.minutes ? `${a.minutes} min` : a.embed_url ? "Video" : ""}
        </span>
      </div>
      <h3 className="mt-5 font-display text-lg font-bold leading-snug tracking-tight text-navy-ink transition-colors group-hover:text-navy">{a.title}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-slate2">{a.excerpt}</p>
      {a.placeholder ? (
        <span className="mt-5 inline-flex items-center gap-1.5 font-display text-xs font-bold text-navy/50">Full article coming soon <ArrowRight className="h-3.5 w-3.5" /></span>
      ) : (
        <span className="mt-5 inline-flex items-center gap-1.5 font-display text-xs font-bold text-navy group-hover:text-gold">Read article <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></span>
      )}
    </>
  );
  const cls = "group flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lg md:p-7";
  return a.placeholder
    ? <article data-testid={`article-card-${a.slug}`} className={cls}>{inner}</article>
    : <Link to={`/blog/${a.slug}`} data-testid={`article-card-${a.slug}`} className={cls}>{inner}</Link>;
};

export const EducationSection = () => {
  const { articles } = useBlog();
  return (
    <section className="section bg-mist/60" data-testid="education-section">
      <div className="container-x">
        <SectionHead eyebrow="ANFORD Intelligence" title="Better property decisions start with better information." />
        <div className="mt-10 grid gap-4 md:mt-14 md:grid-cols-3 md:gap-6">
          {articles.slice(0, 3).map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08} className={i === 2 ? "hidden md:block" : ""}>
              <ArticleCard a={a} />
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-10">
          <Link to="/blog" data-testid="education-view-all-link" className="btn-secondary w-full sm:w-auto">View all insights <ArrowRight className="h-4 w-4" /></Link>
        </Reveal>
      </div>
    </section>
  );
};
